document.addEventListener("DOMContentLoaded", () => {

    const forms = document.querySelectorAll<HTMLFormElement>("form");

    forms.forEach((form) => {
        if (form.action.includes("Logout")) return;
        const inputs = form.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>("input, select,textarea");
        if (inputs.length === 0) return; 
        inputs.forEach((input) => {

           
            input.addEventListener("input", () => {
                //if (input.dataset.pan) {
                //    input.value = input.value.toUpperCase();
                //}

                const errorSpan = input.closest(".floating-input") ?.querySelector(".error-message");
                if (errorSpan) {
                    errorSpan.textContent = "";
                }

                validateField(input);
            });
            //input.addEventListener("paste", (e: ClipboardEvent) => {
            //    if (input.dataset.amount) {
            //        const pasteData = e.clipboardData?.getData("text") || "";
            //        if (!/^[0-9]+$/.test(pasteData)) {
            //            e.preventDefault();
            //        }
            //    }
            //});
            
            input.addEventListener("keypress", (e: KeyboardEvent) => {
                restrictCharacters(e, input);

                
                if (input instanceof HTMLInputElement) {
                    restrictMobileFirstDigit(e, input);
                }
            });

        });

        //form.addEventListener("submit", (e) => {

        //    let isValid = true;

        //       const sponsorInput = document.getElementById("sponsorId") as HTMLInputElement | null;
        //       const placementInput = document.getElementById("Placementid") as HTMLInputElement | null;

        //        const sponsorHidden = document.getElementById("SponsorRegid") as HTMLInputElement | null;
        //        const placementHidden = document.getElementById("PlacementRegid") as HTMLInputElement | null;

        //        if (!placementInput || placementInput.value.trim() === "") {
        //            placementHidden.value = sponsorHidden.value;
        //        }


        //    inputs.forEach((input) => {
        //        if (!validateField(input)) {
        //            isValid = false;
        //        }
        //    });
        //    const dobInput = document.getElementById("TxtDOB") as HTMLInputElement;
        //    if (dobInput) {
        //        if (!validateField(dobInput)) {
        //            isValid = false;
        //        }
        //    }

        //    if (!isValid) {
        //        e.preventDefault();
        //    }

        //});       
        //form.addEventListener("submit", (e) => {
        //    let isValid = true;
        //    handleSponsorPlacementMapping(
        //        "sponsorId",
        //        "Placementid",
        //        "SponsorRegid",
        //        "PlacementRegid"
        //    );
        //    inputs.forEach((input) => {
        //        if (!validateField(input)) {
        //            isValid = false;
        //        }
        //    });
        //    const dobInput = document.getElementById("TxtDOB") as HTMLInputElement;
        //    if (dobInput && !validateField(dobInput)) {
        //        isValid = false;
        //    }
        //    if (!isValid) {
        //        e.preventDefault();
        //    }

        //});

        form.addEventListener("submit", (e) => {

            let isValid = true;

            handleSponsorPlacementMapping(
                "sponsorId",
                "Placementid",
                "SponsorRegid",
                "PlacementRegid"
            );

            inputs.forEach((input) => {

                if (!validateField(input)) {
                    isValid = false;
                }
            });

            const dobInput =
                document.getElementById("TxtDOB") as HTMLInputElement;

            if (dobInput && !validateField(dobInput)) {
                isValid = false;
            }

            if (!isValid) {

                e.preventDefault();
                e.stopPropagation();

                return;
            }

        });
    });

});
function handleSponsorPlacementMapping(
    sponsorId: string,
    placementId: string,
    sponsorHiddenId: string,
    placementHiddenId: string
): void {

    const sponsorInput = document.getElementById(sponsorId) as HTMLInputElement | null;
    const placementInput = document.getElementById(placementId) as HTMLInputElement | null;
    const sponsorHidden = document.getElementById(sponsorHiddenId) as HTMLInputElement | null;
    const placementHidden = document.getElementById(placementHiddenId) as HTMLInputElement | null;

    if (
        sponsorInput &&
        sponsorHidden &&
        placementHidden &&
        sponsorInput.value.trim() !== ""
    ) {
        if (!placementInput || placementInput.value.trim() === "") {
            placementHidden.value = sponsorHidden.value;
        }
    }
}


document.addEventListener("change", (e) => {
    const target = e.target as HTMLInputElement | HTMLSelectElement  | HTMLTextAreaElement;
    if (target.matches("input, select")) {
        validateField(target);
    }
});
function validateField(input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement): boolean {
    const value = input.value.trim();
    const minlength = input.dataset.minlength;
    const errorSpan = input.closest(".floating-input")?.querySelector(".error-message");
    const label = input.closest(".floating-input")?.querySelector("label");
    const fieldName = label?.textContent?.replace("*", "").trim() || "This field";
    const isRequired = input.hasAttribute("required") || input.dataset.required !== undefined;

    if (errorSpan) errorSpan.textContent = "";

    if (isRequired && (value === "" || value === "select")) {
        if (errorSpan) errorSpan.textContent = `${fieldName} is required`;
        return false;
    }

    if (minlength && value.length < Number(minlength)) {
        if (errorSpan) errorSpan.textContent = `${fieldName} must be at least ${minlength} characters`;
        return false;
    }
    //------------------
    //if (input.dataset.email && value !== "") {
    //    const emailRegex = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    //    if (!emailRegex.test(value)) {
    //        if (errorSpan) errorSpan.textContent = "Enter a valid email address";
    //        return false;
    //    }
    //}

    //if (input.dataset.pan && value !== "") {
    //    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    //    if (!panRegex.test(value)) {
    //        if (errorSpan) errorSpan.textContent = "Invalid PAN format";
    //        return false;
    //    }
    //}

    //if (input.dataset.aadhaar && value !== "") {
    //    const aadhaarRegex = /^[0-9]{12}$/;
    //    if (!aadhaarRegex.test(value)) {
    //        if (errorSpan) errorSpan.textContent = "Aadhaar must be 12 digits";
    //        return false;
    //    }
    //}

    //------------------
    if (fieldName.toLowerCase().includes("mobile") && value !== "") {
        if (!/^[6-9]/.test(value)) {
            if (errorSpan) errorSpan.textContent = "Mobile number must start with 6, 7, 8, or 9";
            return false;
        }
        if (value.length !== 10) {
            if (errorSpan) errorSpan.textContent = "Mobile number must be 10 digits";
          return false;
        }
    }
    if (input.id === "TxtDOB" && value !== "") {

        const selectedDate = new Date(value);
        const today = new Date();

        if (selectedDate > today) {
            if (errorSpan) errorSpan.textContent = "DOB cannot be future";
            return false;
        }
    }

    if (fieldName.toLowerCase().includes("pincode") && value !== "") {
        const pinRegex = /^[1-9][0-9]{5}$/;
        if (!pinRegex.test(value)) {
            if (errorSpan) errorSpan.textContent = "Pincode must be exactly 6 digits";
            return false;
        }
    }
    //-----already used in changepasswords-------------
    //if (input.dataset.password !== undefined && value !== "") {
    //    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;
    //    if (!passwordRegex.test(value)) {
    //        if (errorSpan) errorSpan.textContent =
    //            "Password must have 8 chars, uppercase, lowercase, number & special character";
    //        return false;
    //    }
    //}

    //if (input.dataset.confirmPassword !== undefined && value !== "") {
    //    const passwordInput = document.querySelector("#password") as HTMLInputElement;
    //    if (value !== passwordInput.value) {
    //        if (errorSpan) errorSpan.textContent = "Passwords do not match";
    //        return false;
    //    }
    //}
    //-----already used in changepasswords-------------

    //if (input.dataset.amount && value !== "") {
    //    if (!/^[0-9]+$/.test(value)) {
    //        if (errorSpan) errorSpan.textContent = "Amount must be numbers only";
    //        return false;
    //    }
    //}

    input.addEventListener("paste", (e: ClipboardEvent) => {

        const fieldName = input.dataset.required?.toLowerCase() || "";

        if (fieldName.includes("mobile")) {
            e.preventDefault();

            let pasteData = e.clipboardData?.getData("text") || "";

            pasteData = pasteData.replace(/\D/g, "");

            if (pasteData.length > 0 && !/^[6-9]/.test(pasteData)) {
                pasteData = pasteData.substring(1);
            }

            pasteData = pasteData.substring(0, 10);

            input.value = pasteData;

            validateField(input);
        }

    });
    if (input.dataset.required?.toLowerCase().includes("mobile")) {

        input.value = input.value.replace(/\D/g, "");

        if (input.value.length > 10) {
            input.value = input.value.substring(0, 10);
        }
    }
    //const residence = document.getElementById("Residence") as HTMLTextAreaElement;
    //if (residence) {
    //    if (!residence.value.trim()) {
    //        const errorSpan1 = residence.closest(".floating-input")?.querySelector(".error-message");
    //        if (errorSpan1) errorSpan1.textContent = `Residence is required`;
    //        return false;
    //    }
    //    residence.addEventListener("input", () => {
    //        const errorSpan = residence.closest(".floating-input")?.querySelector(".error-message");
    //        if (errorSpan) {
    //            errorSpan.textContent = "";
    //        }
    //    });
    //}
    //------Incomereport and NEFTReport----------------
    //if (input.dataset.date !== undefined && value !== "") {

    //    const parts = value.split("/");

    //    if (parts.length !== 3) {

    //        if (errorSpan)
    //            errorSpan.textContent = "Invalid date format";

    //        return false;
    //    }

    //    const day = parseInt(parts[0]);
    //    const month = parseInt(parts[1]);
    //    const year = parseInt(parts[2]);

    //    const selectedDate = new Date(year, month - 1, day);

    //    if (isNaN(selectedDate.getTime())) {

    //        if (errorSpan)
    //            errorSpan.textContent = "Invalid date";

    //        return false;
    //    }

    //    const today = new Date();

    //    today.setHours(0, 0, 0, 0);

    //    if (selectedDate > today) {

    //        if (errorSpan)
    //            errorSpan.textContent = `${fieldName} cannot be future`;

    //        return false;
    //    }
    //}

    //------Incomereport and NEFTReport----------------
    return true;
}
function restrictCharacters(event: KeyboardEvent, input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) {

    const char = event.key;

    if (input.dataset.pan) {
        if (!/[A-Za-z0-9]/.test(char)) {
            event.preventDefault();
        }
    }

    const fieldName = input.dataset.required?.toLowerCase() || "";

    if (fieldName.includes("mobile") || fieldName.includes("pincode")) {
        if (!/[0-9]/.test(char)) {
            event.preventDefault();
        }
    }
    /*input.dataset.aadhaar ||*/ /*input.dataset.amount*/
    //---------pincode used------
    //if (input.dataset.numeric !== undefined) {
    //    if (!/[0-9]/.test(char)) {
    //        event.preventDefault();
    //    }
    //}
    //---------pincodeused------
}
//function restrictMobileFirstDigit(event: KeyboardEvent, input: HTMLInputElement) {
//    const fieldName = input.dataset.required?.toLowerCase() || "";

//    if (!fieldName.includes("mobile")) return;

//    const char = event.key;

//    if (!/[0-9]/.test(char)) {
//        event.preventDefault();
//        return;
//    }

//    if (input.value.length === 0 && !/[6-9]/.test(char)) {
//        event.preventDefault();
//        return;
//    }

//    if (input.value.length >= 10) {
//        event.preventDefault();
//    }
//}
function restrictMobileFirstDigit(event: KeyboardEvent, input: HTMLInputElement) {

    const fieldName = input.dataset.required?.toLowerCase() || "";
    if (!fieldName.includes("mobile")) return;

    const char = event.key;

    if (!/[0-9]/.test(char)) {
        event.preventDefault();
        return;
    }

    if (input.value.length === 0 && !/[6-9]/.test(char)) {
        event.preventDefault();
        return;
    }

    if (input.value.length >= 10) {
        event.preventDefault();
    }
}
function makeRandomNumber(length: number): string {
    let text = "";
    const possible = "0123456789";

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * possible.length);
        text += possible.charAt(randomIndex);
    }

    return text;
}